
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import HeaderGroup from '../HeaderGroup/index.vue'
import GuildRuleModal from '../GuildRuleModal/index.vue'
import DescModal from '../DescModal/index.vue'
import MemberListModal from '../MemberListModal/index.vue'
import ConfirmModal from '../ConfirmModal/index.vue'
import EntryModal from '../EntryModal/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { Observer } from 'mobx-vue'
import type { GuildDetail, ModalDataType } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { dataSource_hide_store_key, dataSource_topicMoreOpions } from '@xt/client/dataSource/kindred-spirit/index'
import { EnumMemberStatus, EnumMoreOptions } from '@xt/client/enums/kindred-spirit'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/guild'
import { EnumAppletsType } from '@xt/client/enums/wechat'

export enum EnumStatus {
  Assistance = 'assistance',
  Share = 'share',
  Recruit = 'recruit'
}

@Observer
@Component({
  components: {
    HeaderGroup,
    GuildRuleModal,
    DescModal,
    Qrcode,
    MemberListModal,
    ConfirmModal,
    EntryModal
  }
})
export default class IntroPanel extends Vue {
  @Prop({ required: true }) readonly dataSource!: GuildDetail
  @Prop({ required: true }) readonly hasJoin!: boolean
  @Prop({ required: true }) readonly isJoinCity!: boolean
  @Prop({ required: true }) readonly isManager!: boolean
  @Prop({ required: true }) readonly isQuitAudit!: boolean

  showMenu: boolean = false

  shareQrcode: {
    path: string
    query: string
    appletsType: number
  } = {
    path: 'pages/activity/guild/detail/index',
    query: `id=${this.dataSource.id}`,
    appletsType: EnumAppletsType.Uc
  }

  @Ref()
  entryModal: {
    show: () => void
    hide: () => void
  }

  @Ref()
  guildRuleModal: {
    show: () => void
  }

  @Ref()
  descModal: {
    show: (data: { title: string; content: string }) => void
  }

  @Ref()
  memberListModal: {
    show: (data: { guildId: string }) => void
  }

  get GuildStore() {
    return this.$store.$tonghao.Guild
  }

  get TonghaoStore() {
    return this.$store.$tonghao
  }

  get ManagerStore() {
    return this.$store.$tonghao.Manager
  }

  get formatDesc() {
    return this.dataSource.description.replaceAll('\\n', '')
  }

  get hideWaterfall() {
    if (this.dataSource.status === EnumCityStatus.Inited) return false

    if (this.dataSource.recruitStatus === true) {
      return !this.hasJoin ? EnumStatus.Recruit : this.isJoinCity ? EnumStatus.Recruit : EnumStatus.Share
    }

    if (this.dataSource.status === EnumCityStatus.Assistance) {
      return !this.hasJoin ? EnumStatus.Assistance : EnumStatus.Share
    }

    return false
  }

  get contentData() {
    // 未命中指定状态 ｜ 分桐已创建
    if (!this.hideWaterfall) return null

    const operations: Array<{
      key: EnumStatus
      imgPath: string
      desc: string
      btnText: string
    }> = [
      {
        key: EnumStatus.Assistance,
        imgPath: 'assistance',
        desc: '加入城市分桐，助力分桐开放。',
        btnText: '助力'
      },
      {
        key: EnumStatus.Share,
        imgPath: 'assistance',
        desc: '邀请本地桐好，携手共建分桐。',
        btnText: '分享'
      },
      {
        key: EnumStatus.Recruit,
        imgPath: 'recruit',
        desc: '分桐负责人招募中，聚桐好，共长进。',
        btnText: '参与招募'
      }
    ]
    const index = operations.findIndex(item => item.key === this.hideWaterfall)

    return {
      ...operations[index],
      img: `${this.$store.$global.static}/images/topic/pc/city-info-status-${operations[index].imgPath}.png`
    }
  }

  get EnumStatus() {
    return EnumStatus
  }

  get EnumCityStatus() {
    return EnumCityStatus
  }

  get moreOptions() {
    return dataSource_topicMoreOpions.filter(i => {
      if (i.key === EnumMoreOptions.Manager) return this.isManager ? true : false

      if (i.key === EnumMoreOptions.CancelExit) return this.isQuitAudit

      if (i.key === EnumMoreOptions.Exit) return !this.isQuitAudit

      return true
    })
  }

  get memberIds() {
    return this.dataSource.memberIds ?? []
  }

  get bgImg() {
    return this.dataSource.cover || this.$images.topic_intro_bg_img
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  openMemberListModal() {
    if (!this.memberListModal) return

    this.memberListModal.show({
      guildId: this.dataSource.id
    })
  }

  openDescModal() {
    if (!this.descModal || !this.dataSource.description) return

    this.descModal.show({
      title: `${this.dataSource.cityName}分桐`,
      content: this.dataSource.description
    })
  }

  openRuleModal() {
    if (!this.guildRuleModal) return

    this.guildRuleModal.show()
  }

  openMenu() {
    this.showMenu = true
  }

  hideMenu() {
    this.showMenu = false
  }

  handleShowJoin() {
    if (!this.UserInfo.id) {
      this.$emit('unauthorized')
      return
    }

    this.$emit('show-join', this.dataSource)
  }

  handleShowRecruit() {
    if (!this.TonghaoStore.dataSource) return

    window.open(this.TonghaoStore.dataSource.recruitUrl, '_blank')
  }

  handleOtherOp(key: EnumStatus) {
    if (!this.UserInfo.id) {
      this.$emit('unauthorized')
      return
    }

    const modalData: ModalDataType = {
      id: this.dataSource.id,
      cityName: this.dataSource.cityName,
      adcode: this.dataSource.adcode
    }

    if (key === EnumStatus.Assistance) {
      this.$emit('show-assistance', modalData)
    } else if (key === EnumStatus.Share) {
    } else if (this.dataSource.recruitStatus === true && key === EnumStatus.Recruit) {
      if (this.isJoinCity) {
        this.handleShowRecruit()
        return
      }
      this.$emit('show-recruit', modalData)
    }
  }

  async handleMenuOperation({ key }: { key: EnumMoreOptions }) {
    switch (key) {
      case EnumMoreOptions.List:
        window.open('/topic/city-list', '_blank')
        break
      case EnumMoreOptions.Manager:
        window.open(`/topic/manager?id=${this.dataSource.id}`, '_blank')
        break
      case EnumMoreOptions.Exit:
        try {
          const res = await this.ManagerStore.handleAppleExit({
            guildId: this.dataSource.id
          })
          if (res === true) {
            if (this.dataSource.status === EnumCityStatus.Assistance) {
              this.$emit('handle-exit')
            } else {
              this.GuildStore.updateJoinedCity({
                memberStatus: EnumMemberStatus.QuitAudit
              })
              this.$message.success('分桐退出申请审核中')
            }
          }
        } catch (error) {}
        break
      case EnumMoreOptions.CancelExit:
        try {
          const exit = await this.ManagerStore.handleCancelExit({
            guildId: this.dataSource.id
          })

          if (exit) {
            this.GuildStore.updateJoinedCity({
              memberStatus: EnumMemberStatus.Join
            })
            this.$message.success('取消退出成功')
          } else {
            this.$message.error('取消退出失败')
          }
        } catch (error) {}
        break
      default:
        break
    }
    this.showMenu = false
  }

  // 完善个人信息弹窗显示
  checkShowEntryModal() {
    if (!this.UserInfo.id) return

    if (!!localStorage.getItem(dataSource_hide_store_key.hideImproveModalStoreKey) === true) return

    // 仅展示一次
    localStorage.setItem(dataSource_hide_store_key.hideImproveModalStoreKey, 'true')

    this.entryModal.show()
  }

  created(): void {}

  mounted(): void {
    // 刷新进入检测
    if (this.hasJoin && this.isJoinCity) {
      this.checkShowEntryModal()
    }
  }

  updated(): void {}

  destroyed(): void {}
}
